<template>
  <div>
    <div v-loading="loading">
      <div class="d-flex">
        <div class="pr-2">
          <el-image
            :src="defaultImageUrl"
            :preview-src-list="[defaultImageUrl]"
            style="width:150px; height:150px"
          >
            <div slot="error" class="image-slot">
              <img
                src="/image/static/img/nopic.jpg"
                style="width:150px; height:150px"
              />
            </div>
          </el-image>
        </div>
        <div style="flex:1">
          <div class="el-descriptions border-bottom-none">
            <div class="el-descriptions__body">
              <div
                class="el-descriptions__table is-bordered el-descriptions--small"
              >
                <div class="el-descriptions-row">
                  <div
                    class="el-descriptions-item__cell el-descriptions-item__label is-bordered-label"
                  >
                    <div class="sku_main">
                      <div>
                        <span v-if="formData.goodsName">
                          {{ formData.goodsName }}
                        </span>
                        <span v-if="formData.goodsNameEn">
                          {{ formData.goodsNameEn }}
                        </span>
                        <span v-if="formData.masterCategoryName">
                          {{ `(${formData.masterCategoryName})` }}
                        </span>
                      </div>
                      <div>
                        <span v-if="formData.amzSkuNo">
                          {{ formData.amzSkuNo }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <el-descriptions border size="small" :column="3">
            <el-descriptions-item
              :label="$l('form_label_amzSkuNo') || 'SKU'"
              :labelStyle="{ width: '140px' }"
              :contentStyle="{ width: '200px' }"
            >
              {{ formData.amzSkuStoreNo }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_asinCode') || 'ASIN'"
              :labelStyle="{ width: '140px' }"
              :contentStyle="{ width: '200px' }"
            >
              {{ formData.asinCode }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_fnskuCode') || 'FNSKU'"
              :labelStyle="{ width: '140px' }"
              :contentStyle="{ width: '200px' }"
            >
              {{ formData.fnskuCode }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_submitQty') || '补货数量'"
              :labelStyle="{ width: '140px' }"
              :contentStyle="{ width: '200px' }"
            >
              <span style="color: #409EFF">{{ submitQty }}</span>
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_unitInBox') || '装箱入数'"
              :labelStyle="{ width: '140px' }"
              :contentStyle="{ width: '200px' }"
            >
              {{ unitInBox }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_ctnQty') || '补货箱数'"
              :labelStyle="{ width: '140px' }"
              :contentStyle="{ width: '200px' }"
            >
              {{ ctnQty }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_shortageQty') || '缺货数量'"
              :labelStyle="{ width: '140px' }"
              :contentStyle="{
                width: '200px',
                color: shortageQty !== '0' ? 'red' : '',
              }"
            >
              {{ shortageQty }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_etaDate') || '预计上架日期'"
              :labelStyle="{ width: '140px' }"
              :contentStyle="{ width: '200px' }"
            >
              {{ formData.etaDate }}
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </div>

      <div class="side-frame">
        <span style="font-size: 14px; color: #606266">
          {{ $l('form_label_showFba') || 'FBA货件跟踪' }}
        </span>
      </div>
      <ScmFbaTable :amzReplenishmentDetailCode="amzReplenishmentDetailCode" />

      <div class="side-frame-warning">
        <span style="font-size: 14px; color: #606266">
          {{ $l('form_label_reply_information') || '返答信息' }}
        </span>
      </div>
      <SkuReplyTable :amzReplenishmentDetailCode="amzReplenishmentDetailCode" />
    </div>
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import { format, subtract, divide, roundDown } from '@/libs/util.number.js'
import SkuReplyTable from '../sku-reply-table'
import ScmFbaTable from '../scm-fba-table'
export default {
  components: { SkuReplyTable, ScmFbaTable },
  mixins: [EditLoading],
  props: { amzReplenishmentDetailCode: { type: String, default: '' } },
  data() {
    return {
      formData: {},
      loading: false,
    }
  },
  computed: {
    submitQty() {
      return format(this.formData.submitQty)
    },
    unitInBox() {
      return format(this.formData.unitInBox)
    },
    invQty() {
      return format(this.formData.invQty)
    },
    ctnQty() {
      const { submitQty, unitInBox } = this.formData
      return format(roundDown(divide(submitQty, unitInBox), 1)) || '0'
    },
    shortageQty() {
      const { submitQty, invQty } = this.formData
      const shortageQty = subtract(submitQty, invQty)
      return format(shortageQty || 0)
    },
    defaultImageUrl() {
      const { defaultImageUrl } = this.formData
      return defaultImageUrl || '/image/static/img/nopic.jpg'
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.amzReplenishmentDetailCode) return
      this.loading = true
      const res = await this.$api
        .ecomAmzReplenishmentDetailDetailApi({
          amzReplenishmentDetailCode: this.amzReplenishmentDetailCode,
        })
        .catch(() => null)
      this.loading = false
      const { body } = res || {}
      this.formData = body || {}
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .border-top-none {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-top: none !important;
    }
  }
  .border-bottom-none {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-bottom: none !important;
    }
  }
}
.sku_main {
  font-size: 13px;
  font-weight: bold;
  color: #333;
}
</style>
